// removed by extract-text-webpack-plugin
module.exports = {"AccessoryBodyTypeTabName":"AccessoryBodyTypeTabName"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-body-type-tab-name/styles.css
// module id = 872
// module chunks = 0 1